import styled from "@emotion/styled";

import { fontMerriweather } from "shared/lib/styles";

import { BaseImage } from "scmp-app/components/common/base-image";
import { SignUpButton } from "scmp-app/components/newsletter/sign-up-button";

export const StyledSignUpButton = styled(SignUpButton)`
  max-inline-size: 140px;
`;

export const PlaceholderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  inline-size: 100%;
  block-size: auto;

  background-color: #e2e2e2;
  aspect-ratio: 3/2;

  svg {
    inline-size: 80px;
    block-size: 64px;
    margin: auto;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;
  align-self: stretch;

  inline-size: 289px;
  block-size: 100%;
  max-inline-size: 300px;
  padding: 12px;

  border: 1px solid #cccccc;

  background: #ffffff;

  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.15);
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Name = styled.span`
  color: #000000;
  font-weight: 700;
  font-size: 18px;
  font-family: ${fontMerriweather};
  font-style: normal;
  line-height: 130%;
  font-feature-settings:
    "liga" off,
    "clig" off;
`;

export const Footer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  inline-size: 100%;
  margin-block-start: auto;
`;

export const ImageContainer = styled.div`
  display: grid;
  grid-template-rows: repeat(2, 50%);
  grid-template-columns: repeat(2, 50%);

  inline-size: 100%;
  block-size: auto;
  aspect-ratio: 3/2;

  background-color: #f2f2f2;
`;

export const StyledBaseImage = styled(BaseImage)`
  background: transparent;
`;

export const Including = styled.div`
  margin-block-start: 12px;

  color: #000000;
  font-weight: 400;
  font-size: 12px;
  font-family: ${fontMerriweather};
  font-style: italic;
  line-height: 140%;
  text-transform: lowercase;
  text-decoration-style: solid;
  text-decoration-skip-ink: auto;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
`;

export const NewsletterNames = styled.div`
  span {
    color: #000000;
    font-weight: 400;
    font-size: 14px;
    font-family: ${fontMerriweather};
    font-style: normal;
    line-height: 140%;

    &:first-of-type {
      font-weight: 700;
    }
  }
`;
